import { NotFoundError } from 'shared/domains/errors';

function NotFound() {
  return <NotFoundError />;
}

export default NotFound;
